export default __webpack_public_path__ + "static/media/Search_institution_blue.9f37d7a2.svg";